import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import { GlobalSetting } from '@adornis/buchungsheld-db/entities/global-setting.js';
import { Institution } from '@adornis/buchungsheld-db/entities/institution.js';
import '@adornis/buchungsheld-theme/components/tr-section.js';
import '@adornis/buchungsheld-theme/fonts/fonts.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { routingState } from '@adornis/router/client/routing-state.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { of, switchMap } from 'rxjs';

@customElement('bh-page-privacy')
export class BHPagePrivacy extends BuchungsheldLitElement {
  @state() private readonly _globalSettings = new RXController(
    this,
    GlobalSetting.getGlobalSetting()(GlobalSetting.allFields),
  );
  @state() private readonly _institutionID = new RXController(this, routingState.searchParams.get('institution'));
  @state() private readonly _institution = new RXController(this, this._institutionID.observable, institutionID$ =>
    institutionID$.pipe(
      switchMap(institutionID =>
        institutionID
          ? Institution.getByID<Institution>(institutionID)({
              privacy: 1,
              imprint: 1,
              accessibility: 1,
              termsOfUse: 1,
              globalSettings: GlobalSetting.allFields,
            })
          : of(null),
      ),
    ),
  );

  override render() {
    if (this._globalSettings.isLoading || this._institution.isLoading)
      return html` <tr-loading-state></tr-loading-state> `;

    return html`
      <tr-section>
        <tr-h3 bold>${this._translation.translate('privacy')}</tr-h3>

        <br />

        ${unsafeHTML(
          this._institution.value ? this._institution.value.resolvedPrivacy : this._globalSettings.value?.dataPrivacy,
        )}
      </tr-section>
    `;
  }
}
